import { CALL_API } from '../middleware/ApiMiddleware';

export const CASE_ROLE_CREATE_REQUEST = 'CASE_ROLE_CREATE_REQUEST';
export const CASE_ROLE_CREATE_FAILURE = 'CASE_ROLE_CREATE_FAILURE';
export const CASE_ROLE_CREATE_SUCCESS = 'CASE_ROLE_CREATE_SUCCESS';

export const GET_CASE_ROLE_LIST_REQUEST = 'GET_CASE_ROLE_LIST_REQUEST';
export const GET_CASE_ROLE_LIST_FAILURE = 'GET_CASE_ROLE_LIST_FAILURE';
export const GET_CASE_ROLE_LIST_SUCCESS = 'GET_CASE_ROLE_LIST_SUCCESS';

export const GET_CASE_ROLE_REQUEST = 'GET_CASE_ROLE_REQUEST';
export const GET_CASE_ROLE_FAILURE = 'GET_CASE_ROLE_FAILURE';
export const GET_CASE_ROLE_SUCCESS = 'GET_CASE_ROLE_SUCCESS';

export const EDIT_CASE_ROLE_REQUEST = 'EDIT_CASE_ROLE_REQUEST';
export const EDIT_CASE_ROLE_FAILURE = 'EDIT_CASE_ROLE_FAILURE';
export const EDIT_CASE_ROLE_SUCCESS = 'EDIT_CASE_ROLE_SUCCESS';

export const EDIT_CASE_ROLE_SEQUENCE_REQUEST = 'EDIT_CASE_ROLE_SEQUENCE_REQUEST';
export const EDIT_CASE_ROLE_SEQUENCE_FAILURE = 'EDIT_CASE_ROLE_SEQUENCE_FAILURE';
export const EDIT_CASE_ROLE_SEQUENCE_SUCCESS = 'EDIT_CASE_ROLE_SEQUENCE_SUCCESS';

const baseURL = 'xerce/config/case-roles';

export const createCaseRole = (createCaseRoleRequest: ICaseRoleRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}`,
    method: 'post',
    body: createCaseRoleRequest,
    authenticated: true,
    types: [CASE_ROLE_CREATE_REQUEST, CASE_ROLE_CREATE_SUCCESS, CASE_ROLE_CREATE_FAILURE],
  },
});

export const fetchCaseRoleList = () => ({
  [CALL_API]: {
    endpoint: `${baseURL}`,
    method: 'get',
    authenticated: true,
    types: [GET_CASE_ROLE_LIST_REQUEST, GET_CASE_ROLE_LIST_SUCCESS, GET_CASE_ROLE_LIST_FAILURE],
  },
});

export const fetchCaseRoleWithAgencyId = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}?agencyId=${agencyId}`,
    method: 'get',
    authenticated: true,
    types: [GET_CASE_ROLE_LIST_REQUEST, GET_CASE_ROLE_LIST_SUCCESS, GET_CASE_ROLE_LIST_FAILURE],
  },
});

export const fetchCaseRole = (caseRoleId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${caseRoleId}`,
    method: 'get',
    authenticated: true,
    types: [GET_CASE_ROLE_REQUEST, GET_CASE_ROLE_SUCCESS, GET_CASE_ROLE_FAILURE],
  },
});

export const updateCaseRole = (caseRoleId: number, createCaseRoleRequest: ICaseRoleRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${caseRoleId}`,
    method: 'put',
    body: createCaseRoleRequest,
    authenticated: true,
    types: [EDIT_CASE_ROLE_REQUEST, EDIT_CASE_ROLE_SUCCESS, EDIT_CASE_ROLE_FAILURE],
  },
});

export const editCaseRoleSequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/sequence`,
    method: 'put',
    body: { sequence },
    authenticated: true,
    types: [EDIT_CASE_ROLE_SEQUENCE_REQUEST, EDIT_CASE_ROLE_SEQUENCE_SUCCESS, EDIT_CASE_ROLE_SEQUENCE_FAILURE],
  },
});
